import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
// import Header from './header';

import 'typeface-work-sans';
import 'typeface-ibm-plex-mono';

import '../styles/main.scss';

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
            description
            keywords
            siteUrl
          }
        }
      }
    `}
    render={(data) => {
      const { siteMetadata } = data.site;

      return (
        <>
          <Helmet>
            <html lang="en" />

            <title>{siteMetadata.title}</title>
            <meta name="description" content={siteMetadata.description} />
            <meta name="keywords" content={siteMetadata.keywords} />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={siteMetadata.title} />
            <meta property="og:description" content={siteMetadata.description} />
            <meta property="og:url" content={siteMetadata.siteUrl} />
            <meta property="og:site_name" content={siteMetadata.title} />
            <meta property="og:image" content={`${siteMetadata.siteUrl}/logo-og-2.jpg`} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:description" content={siteMetadata.description} />
            <meta name="twitter:title" content={siteMetadata.title} />
            <meta name="twitter:image" content={`${siteMetadata.siteUrl}/logo-og-2.jpg`} />
            <meta name="twitter:site" content="@ErwanMuhibbain" />
            <meta name="twitter:creator" content="@wansaleh" />

            <script type="application/ld+json">
              {`
                {
                  "@context": "http://schema.org/",
                  "@type": "WebSite",
                  "name": "${siteMetadata.title}",
                  "image": "${siteMetadata.siteUrl}/logo-og-2.jpg",
                  "description": "${siteMetadata.description}",
                }
              `}
            </script>

            <link href="https://pro.fontawesome.com/releases/v5.3.1/css/all.css" integrity="sha384-9ralMzdK1QYsk4yBY680hmsb4/hJ98xK3w0TIaJ3ll4POWpWUYaA2bRjGGujGT8w" rel="stylesheet" crossOrigin="anonymous" />
          </Helmet>

          {/* <Header siteTitle={siteMetadata.title} /> */}
          <div>{children}</div>
        </>
      );
    }}
  />
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
